import React from "react";
import "./PrevCast.css";
import { ReactComponent as MicrofonePrev } from "../../assets/img/MicrofonePrev.svg";
import { ReactComponent as SetasPrevCast } from "../../assets/img/setasPrevCast.svg";
import { track } from "../../services/analytics";

interface Episode {
  category: string;
  title: string;
  duration: string;
  identificador: string;
}

const episodes: Episode[] = [
  {
    category: "APRENDIZADO",
    title: "Dicas Para Envelhecer Bem",
    duration: "21m28s",
    identificador: "dicas_envelhecer_bem",
  },
  {
    category: "INVESTIMENTOS",
    title: "Resultados do terceiro trimestre na Forluz e perspectivas futuras",
    duration: "26m37s",
    identificador: "resultados_terceiro_trimestre_forluz_perspectivas_futuras",
  },
];

const PrevCast: React.FC = () => {
  const trackEpisode = (identificador: string) => {
    track("prevcast_clique", {
      identificador,
      destino: "soundcloud",
      tipo_destino: "url",
    });
  };

  return (
    <section className="prevcast-container">
      <div className="prevcast-content">
        <div className="prevcast-left">
          <MicrofonePrev className="microphone-icon" />
          <h2>
            <span className="prev">Prev</span>
            <span className="cast">Cast</span>
          </h2>
          <p>
            Escute nossas pílulas de previdência para conhecer mais sobre os
            planos.
          </p>
        </div>
        <div className="prevcast-right">
          {episodes.map((ep, idx) => (
            <div className="episode" key={idx}>
              <span className="category">{ep.category}</span>
              <div className="info">
                <div>
                  <span className="prevcast-span">{ep.title}</span>
                  <div className="duration">{ep.duration}</div>
                </div>
                <a
                  href="https://soundcloud.com/forluz"
                  className="play-button"
                  aria-label={`Reproduzir ${ep.title}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => trackEpisode(ep.identificador)}
                >
                  <SetasPrevCast className="play-button" />
                </a>
              </div>
              {idx !== episodes.length - 1 && <hr />}
            </div>
          ))}
          <hr />
          <a
            href="https://soundcloud.com/forluz"
            className="see-all"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() =>
              track("prevcast_clique", {
                identificador: "ver_todos",
                destino: "ver_todos",
                tipo_destino: "url",
              })
            }
          >
            Ver todos <span className="arrow">→</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default PrevCast;
